import { connect } from 'react-redux';
import { getPostPageEnabled } from '@wix/communities-blog-client-common';

import { getConfig } from '../services/config';

const withSectionUrl = (WrappedComponent) => {
  const mapStateToProps = (state) => {
    const { sectionUrl: feedSectionUrl, postPageSectionUrl } = getConfig();
    const isPostPageEnabled = getPostPageEnabled(state) && postPageSectionUrl;
    const sectionUrl = isPostPageEnabled ? postPageSectionUrl : feedSectionUrl;
    return {
      sectionUrl,
    };
  };

  return connect(mapStateToProps, {})(WrappedComponent);
};

export default withSectionUrl;
